import { useQuery } from '@tanstack/react-query'
import ms from 'ms'

import { useCurrentStore } from '@hooks/useCurrentStore'
import { useLayout } from '@state/layout/queries'

interface CashRegister {
  id: string
  x: number
  y: number
  rotation: number
}

interface CashRegisterStore {
  storeName: string
  cashRegisters: CashRegister[]
}

const cashRegistersD4C9 = [
  { id: '1', x: 20.5, y: 18, rotation: Math.PI / 2 },
  { id: '2', x: 23, y: 15.5, rotation: Math.PI / 2 },
]

const cashRegistersBC = [
  { id: '1', x: 56, y: 17, rotation: Math.PI / 2 },
  { id: '2', x: 56, y: 14, rotation: Math.PI / 2 },
  { id: '3', x: 56, y: 11, rotation: Math.PI / 2 },
  { id: '4', x: 56, y: 8, rotation: Math.PI / 2 },
  { id: '5', x: 56, y: 5, rotation: Math.PI / 2 },
]

const cashRegistersBNT = [
  { id: '1', x: 5, y: 3, rotation: Math.PI / 2 },
  { id: '1', x: 5, y: 6, rotation: Math.PI / 2 },
  { id: '1', x: 5, y: 12, rotation: Math.PI / 2 },
]

const registers: CashRegisterStore[] = [
  { storeName: 'D4C9', cashRegisters: cashRegistersD4C9 }, // name of D4C9 on dev-ureka.ubica.ai and local
  { storeName: 'Drogeriemarkt', cashRegisters: cashRegistersD4C9 }, // name of D4C9 on ubica.ai

  {
    storeName: 'D1JD',
    cashRegisters: [
      { id: '3', x: 32.5, y: 7, rotation: 0 },
      { id: '4', x: 30.5, y: 10, rotation: 0 },
    ],
  },

  { storeName: 'zBNT', cashRegisters: cashRegistersBNT }, // buenting local
  { storeName: 'BNT-110111', cashRegisters: cashRegistersBNT }, // buenting on dev-ureka.ubica.ai
  { storeName: 'Supermarkt', cashRegisters: cashRegistersBNT }, // buenting on ubica.ai

  { storeName: 'zBC', cashRegisters: cashRegistersBC }, // buyCountry on local
  { storeName: '8890', cashRegisters: cashRegistersBC }, // buyCountry on dev-ureka.ubica.ai
  { storeName: 'KLND-8890', cashRegisters: cashRegistersBC }, // buyCountry on dev-ureka.ubica.ai
  { storeName: 'Einzelhandelsfiliale', cashRegisters: cashRegistersBC }, // buyCountry on ubica.ai
]

export function useCashRegisters() {
  const store = useCurrentStore()
  const { data: layout } = useLayout({ complete: false })

  const storeName = store.name

  return useQuery<CashRegister[]>({
    queryKey: ['cash-registers', storeName],
    queryFn: async () => {
      const cashRegisterStore = registers.find(store => store.storeName === storeName)
      if (!cashRegisterStore) {
        return []
      }

      return cashRegisterStore.cashRegisters
    },
    staleTime: ms('1d'),
    enabled: layout !== undefined,
  })
}
